import {
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  ActivityIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  AddUserIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  BarLineChartIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  BrowserTransferIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  CircleOutlineIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  DomainIcon,
  EmptyPersonIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  PuzzleIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  ShieldTickIcon,
} from '@latitude/icons';
import type { ComponentType } from 'react';

type MenuIconComponent = ComponentType<{ className?: string }>;

// Canonical icon-key -> icon component map for the KYC nav menus, shared
// between the onboarding app's NavigationMenu and the questionnaire-builder
// feature's SideMenu preview panel.
const MENU_ICONS: Record<string, MenuIconComponent> = {
  use_outline: EmptyPersonIcon,
  user_outline: EmptyPersonIcon,
  user_add: AddUserIcon,
  business: DomainIcon,
  browser_transfer: BrowserTransferIcon,
  shield_tick: ShieldTickIcon,
  puzzle_piece: PuzzleIcon,
  activity: ActivityIcon,
  bar_line_chart: BarLineChartIcon,
};

// Falls back to a generic outline icon for unrecognized keys
export function getMenuIcon(icon: string): MenuIconComponent {
  return MENU_ICONS[icon] ?? CircleOutlineIcon;
}
